<script>
import CredentialsService from '@/services/credentials.service'

export default {
    name: 'ApiDemo',
    data () {
        return {
            apiKey: '',
            listAPIKey: [],
            apiType: 'curl',
            demoUrl: ''
        }
    },
    created () {
        this.getAPIKey()
    },
    methods: {
        getAPIKey () {
            this.$appService.showLoading()
            CredentialsService.getListCredentials(this.$route.params.project_id).then(
                result => {
                    this.listAPIKey = result.map(apiKey => {
                        return {
                            text: apiKey.name,
                            value: apiKey.key
                        }
                    })
                    if (this.listAPIKey.length > 0) {
                        this.apiKey = this.listAPIKey[0].value
                    }
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$t('load'),
                    item: this.$t('apiKeyList')
                }))
            ).finally(this.$appService.hideLoading)
        }
    }
}
</script>
